import { render, staticRenderFns } from "./ComplianceReviewDetails.vue?vue&type=template&id=139871f3&scoped=true"
import script from "./ComplianceReviewDetails.vue?vue&type=script&lang=js"
export * from "./ComplianceReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReviewDetails.vue?vue&type=style&index=0&id=139871f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139871f3",
  null
  
)

export default component.exports